import { render, staticRenderFns } from "./siteJiedu.vue?vue&type=template&id=d74d4372&scoped=true"
import script from "./siteJiedu.vue?vue&type=script&lang=js"
export * from "./siteJiedu.vue?vue&type=script&lang=js"
import style0 from "./siteJiedu.vue?vue&type=style&index=0&id=d74d4372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74d4372",
  null
  
)

export default component.exports